import React, { useState } from 'react'
import List from './List'
import AddFiAgent from './AddFiAgent'


export default function Main() {
    const [tab, setTab] = useState("list")
    const [editData, setEditData] = useState({})

    const handleTab = (data, pageType) => {
        console.log("data",data)
        setEditData(data)
        setTimeout(()=>{
            setTab(pageType)
        },200)
    }
    return (
        <>
            <div className="communitySection" style={{ marginTop: '20px' }}>
                {
                    tab == "list" ?
                        <List handleTab={handleTab} />
                        : ''}

                {
                    tab == "addEdit" ?
                        <AddFiAgent Detaildata={editData} handleTab={handleTab} />
                        : ''
                }

            </div>
        </>
    )
}
